import { render } from "./Bussines.vue?vue&type=template&id=09163cae"
import script from "./Bussines.vue?vue&type=script&lang=js"
export * from "./Bussines.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__